// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestedUserCard-cls1_Ngt","cls2":"SuggestedUserCard-cls2_Hd7 SuggestedUserCard-cls1_Ngt"};